import { PrepaySubscriptionVariant } from '../posthog/prepay-subscription-variant.enum';
import { RegisteredItemProductDetails } from '../registered-item/registered-item-product-details.interface';
import { RegistrationSystemCode } from '../registration/registration-system-code.enum';
import { CmsProtectionDetailsUpsellModal } from './cms-protection-details-upsell-modal.interface';

export interface ProtectionDetailsUpsellModalData {
  cmsProtectionDetailsUpsellModal: CmsProtectionDetailsUpsellModal;
  merchandiseBrand?: string;
  annualPlansEnabled?: boolean;
  prepaySubscriptionVariant: PrepaySubscriptionVariant | null;
  promotionalPriceEnabled: boolean;
  registeredItemHasAnnualPayment: boolean;
  registeredItemProductDetails?: RegisteredItemProductDetails;
  registeredItemAnnualProductDetails?: RegisteredItemProductDetails;
  registeredItemProducts?: RegisteredItemProductDetails[];
  systemCode: RegistrationSystemCode;
}
